import { observer } from 'mobx-react';
import { useState } from 'react';
import { CalendarIcon, CloseIcon } from '../../../VaultFilters/icons';
import { AddButton, RemoveTagButton, TagCategory, TagCategoryTitle, TagPill, TagsList, TagText } from '../shared/TagCategory.styles';
import { useStore } from '../../../../../app/data/root.store';
import { ActionLockedIconWithTooltip } from '../../../../../../common/components/ActionLocked/ActionLockedIconWithTooltip';
import { PeriodEditor } from './PeriodEditor';

export const PeriodTagCategory = observer(({ periodTags, onUpdate }) => {
    const [showPeriodEditor, setShowPeriodEditor] = useState(false);
    const { userStore } = useStore();

    const showEditor = () => {
        if (userStore.isActionBlockedByRole('editVaultFileMetadata')) {
            userStore.setShowLimitedSharedAccess(true);
            return;
        }

        setShowPeriodEditor(true);
    };

    const handleRemoveTag = (tagToRemove) => {
        if (userStore.isActionBlockedByRole('editVaultFileMetadata')) {
            userStore.setShowLimitedSharedAccess(true);
            return;
        }

        const updatedPeriods = periodTags.filter(tag => tag !== tagToRemove);
        onUpdate(updatedPeriods);
    };

    const handlePeriodSave = (period) => {
        onUpdate([period]);
        setShowPeriodEditor(false);
    };

    return (
        <TagCategory>
            <TagCategoryTitle>Period {userStore.isActionBlockedByRole('editVaultFileMetadata') && <ActionLockedIconWithTooltip iconColor={'#ACB1BB'} isRoleBlocked={true} marginLeft={'0px'} />}
            </TagCategoryTitle>
            {
                showPeriodEditor ? (
                    <PeriodEditor
                        tag={periodTags?.[0]}
                        showButtons={true}
                        onSave={handlePeriodSave}
                        onCancel={() => setShowPeriodEditor(false)}
                    />
                ) : (
                    <>
                        {
                            periodTags.length > 0 && (
                                <TagsList>
                                    {
                                        periodTags.map((tag, index) => (
                                            <TagPill key={index} onClick={() => showEditor()}>
                                                <CalendarIcon />
                                                <TagText>{tag}</TagText>
                                                <RemoveTagButton
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemoveTag(tag);
                                                    }}
                                                >
                                                    <CloseIcon />
                                                </RemoveTagButton>
                                            </TagPill>
                                        ))
                                    }
                                </TagsList>
                            )
                        }
                        {
                            periodTags.length === 0 &&
                            <AddButton onClick={showEditor}>+ Add</AddButton>
                        }
                    </>
                )
            }
        </TagCategory>
    );
}); 